<template>
  <el-scrollbar height="400px">
    <prism-editor class="my-editor" v-model="inputValue" :highlight="highlighter" line-numbers style="max-height: max-content;"></prism-editor>
  </el-scrollbar>
</template>

<script setup>
import { computed} from 'vue'
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'
import './prism/prism'
import './prism/prism.css'

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])

const inputValue = computed({
  get() {
    return props.modelValue
  },

  set(v) {
    emit('update:modelValue', v)
  }
})

function highlighter(code) {
  return Prism.highlight(code, Prism.languages.json)
}


</script>

<style scoped>
.my-editor {
  border: 1px solid #eeeeee;
  max-height: 400px;
  font-family: Fira code,Fira Mono,Consolas,Menlo,Courier,monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px 10px;
  margin: 10px 0;
  /* max-height: max-content; */
}
::v-deep .prism-editor__textarea.prism-editor__textarea--empty {
  padding-left: 2px;
}
</style>
